import { IBuildingCreate } from "Dashboard/scenes/HighRiseSales/domain/IBuildingCreate";
import { useAppDispatch } from "hooks/hooks";
import {
  getBuildingsList,
  //   addNewBuilding,
  setNewBuildingPopover,
} from "../main.slice";
import {
  Control,
  Controller,
  FieldErrorsImpl,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormReset
} from "react-hook-form";
import { hrsService } from "../../../services/hrs.services";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { FormatDateIso } from "utils/dateUtils";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import PartnerSimpleSelect from "Dashboard/scenes/Partners/components/PartnerSimpleSelect";
import MunicipalitySelect from "Dashboard/scenes/Partners/components/MunicipalitySelect";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesHRS from "../../../styles/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { IOption } from "Dashboard/domain/IOption";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IBuildingCreate>;
  register: UseFormRegister<IBuildingCreate>;
  control: Control<IBuildingCreate, any>;
  errors: Partial<FieldErrorsImpl<IBuildingCreate>>;
  reset: UseFormReset<IBuildingCreate>;
  investorValue: IOption | undefined;
  setInvestorValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
  municipalityValue: IOption | undefined;
  setMunicipalityValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
};

const NewBuildingPopover = (props: IProps) => {
  const dispatch = useAppDispatch();

  const {
    handleSubmit,
    register,
    control,
    errors,
    reset,
  } = props;

  const close = () => {
    dispatch(setNewBuildingPopover({ isOpen: false }));
    resetForm();
  };

  const resetForm = () => {
    reset();
    props.setInvestorValue(undefined);
    props.setMunicipalityValue(undefined);
  };

  const onSubmit = async (data: IBuildingCreate) => {
    try {
      await hrsService.createBuilding(data);
      dispatch(getBuildingsList({}));
      toast.success("Zgrada je uspešno dodata.");
      close();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`${classesHRS.newBuildingPopover} ${classes.basicPopover}`}
    >
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>naziv projekta</label>
          <input type="text" className={`${classes.itemBorder}
            ${errors.fullName ? classes.itemError : ""}`}
            {...register("fullName", { required: true })} />
        </div>
      </div>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>naručilac</label>
          <Controller
            name="investorId"
            control={control}
            defaultValue={undefined}
            render={({ field: { onChange } }) => (
              <PartnerSimpleSelect
                value={props.investorValue}
                setValue={props.setInvestorValue}
                customStyles={styles.customStyleClassic}
                onChange={onChange}
              // error={errors.projectId}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>mesto</label>
          <Controller
            name="municipalityId"
            control={control}
            defaultValue={undefined}
            rules={{ required: true, }}
            render={({ field: { onChange } }) => (
              <MunicipalitySelect
                value={props.municipalityValue}
                setValue={props.setMunicipalityValue}
                customStyles={styles.customStyleClassic}
                error={errors.municipalityId}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>cena doručka</label>
          <input type="text" className={classes.itemBorder}
            {...register("breakfastCost")} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>cena keš doručka</label>
          <input type="text" className={classes.itemBorder}
            {...register("cashBreakfastRate")} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>cena ručka</label>
          <input type="text" className={classes.itemBorder}
            {...register("lunchCost")} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>cena keš ručka</label>
          <input type="text" className={classes.itemBorder}
            {...register("cashLunchRate")} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>cena večere</label>
          <input type="text" className={classes.itemBorder}
            {...register("dinnerCost")} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>cena keš večere</label>
          <input type="text" className={classes.itemBorder}
            {...register("cashDinnerRate")} />
        </div>
      </div>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum ugovora</label>
          <Controller
            control={control}
            name="contractDate"
            defaultValue={undefined}
            rules={{ required: true, }}
            render={({ field: { onChange, value } }) => (
              <div >
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  dateFormat="dd.MM.yyyy"
                  showMonthDropdown
                  showYearDropdown
                  selected={value ? new Date(value) : null}
                  className={`${classes.dateItem} ${classes.itemBorder}
                    ${errors.contractDate ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum završetka</label>
          <Controller
            control={control}
            name="dueDate"
            defaultValue={undefined}
            rules={{ required: true, }}
            render={({ field: { onChange, value } }) => (
              <div>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  dateFormat="dd.MM.yyyy"
                  showMonthDropdown
                  showYearDropdown
                  selected={value ? new Date(value) : null}
                  className={`${classes.dateItem} ${classes.itemBorder}
                    ${errors.dueDate ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewBuildingPopover;
